module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dropdown"
  }, [_c('a', {
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.validateUpdateContactUser
    }
  }, [_c('user-miniature', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "user": _vm.contact.user
    }
  })], 1), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canUpdateContactUser() && _vm.users.length),
      expression: "canUpdateContactUser() && users.length"
    }],
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.user_options), function(user) {
    return (_vm.showUserOption(user)) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.openUpdateContactUserConfirmationModal(user)
        }
      }
    }, [_vm._v(_vm._s(user.name))])]) : _vm._e()
  }), 0)]), _c('confirm-modal', {
    attrs: {
      "id": "confirm-update-contact-user",
      "title": "Alterar responsável",
      "confirm_text": "Alterar",
      "confirm_class": "btn-primary"
    },
    on: {
      "confirm-modal-confirm": _vm.updateContactUser
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Confirma alteração do responsável abaixo?")]), _c('strong', {
    staticClass: "bold reev-base-green-color"
  }, [_c('br'), _c('span', [_vm._v(_vm._s(_vm.contact.user.name))]), _c('span', {
    staticClass: "separator glyphicon glyphicon-arrow-right text-gray-color"
  }), _c('span', [_vm._v(_vm._s(_vm.selected_user.name))])])]), _c('br')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d367d556!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/user_dropdown.vue
// module id = 1220
// module chunks = 1